import { Component, HostListener, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { HeaderComponent } from './header/header.componenent';
import { FooterComponent } from './footer/footer.component';
import { UserService } from './business-reg/services/userService';
import { GlassboxService } from './business-reg/services/glassboxService';
import { CookieBannerComponent } from "./business-reg/cookie-banner/cookie-banner.component";

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, HeaderComponent, CookieBannerComponent],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  title = 'ClientApp';

  constructor(private router: Router, private userService: UserService, private glassboxService: GlassboxService) {
  }
  ngOnInit(): void {

    this.glassboxService.loadGlassboxScript();

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        let url = event?.url as string;
        if (url?.length > 1) {//check if it s not main page
          if (this.userService?.UserSession?.GoogleHashTag != null) {
            (window as any).dataLayer.push(
              {
                'event': 'userID',
                'user_id': this.userService!.UserSession!.GoogleHashTag
              });
          }
        }
      }
    });
  }
}
